/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Welcome_BackInputs */

const en_auth_login_welcome_back = /** @type {(inputs: Auth_Login_Welcome_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome back`)
};

const es_auth_login_welcome_back = /** @type {(inputs: Auth_Login_Welcome_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenido de nuevo`)
};

/**
* | output |
* | --- |
* | "Welcome back" |
*
* @param {Auth_Login_Welcome_BackInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_login_welcome_back = /** @type {((inputs?: Auth_Login_Welcome_BackInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Welcome_BackInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_login_welcome_back(inputs)
	return es_auth_login_welcome_back(inputs)
});